import React from 'react';
import { CURRENT_SITE } from '../../config-sites';
import previewFavicon from '../assets/favicon-preview.png';
import { SharedTags } from '../shared/metaTags';
export const SEO = ({
    location,
    title,
    children,
    description,
    hideCanonical,
    isPolicy,
}: {
    location: string;
    children?: any;
    title?: string;
    description?: string;
    hideCanonical?: boolean;
    isPolicy?: boolean;
}) => {
    return (
        <>
            <SharedTags isPolicy={isPolicy} />
            {process.env && process.env.NODE_ENV === `development` && (
                <link type="image/x-icon" rel="icon" href={previewFavicon} />
            )}
            {!process.env ||
                (process.env.NODE_ENV !== `development` && (
                    <link type="image/x-icon" rel="icon" href="/favicon.png" />
                ))}

            {children}
            {title && typeof title === `string` && (
                <>
                    <title id="title">
                        {`${title}${CURRENT_SITE.siteTitleSuffix}`}
                    </title>
                    <meta
                        id="og:title"
                        property="og:title"
                        content={`${title}${CURRENT_SITE.siteTitleSuffix}`}
                    />
                    <meta
                        id="twitter:title"
                        name="twitter:title"
                        content={`${title}${CURRENT_SITE.siteTitleSuffix}`}
                    />
                </>
            )}
            {description && (
                <>
                    <meta
                        id="description"
                        name="description"
                        content={description}
                    />
                    <meta
                        id="og:description"
                        property="og:description"
                        content={description}
                    />
                    <meta
                        id="twitter:description"
                        property="twitter:description"
                        content={description}
                    />
                </>
            )}
            <meta
                id="twitter:url"
                key="twitter-url"
                content={`${CURRENT_SITE.siteUrl}${location}`}
            />
            {!hideCanonical && (
                <link
                    id="canonical"
                    rel="canonical"
                    href={`${CURRENT_SITE.siteUrl}${location}`}
                />
            )}
        </>
    );
};
